import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AdvtService } from '../../_services/advt.service';
import { AlertService } from '../../_services/alert.service';
import { Router, ActivatedRoute , NavigationEnd, NavigationStart } from '@angular/router';
import { Http } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationsService } from 'angular2-notifications';
import {Location} from '@angular/common';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operator/filter';



@Component({
  selector: 'app-seller-info',
  templateUrl: './seller-info.component.html',
  styleUrls: ['./seller-info.component.css']
})
export class SellerInfoComponent implements OnInit {
  type;
  type1;
  seller_id;
  currentUser;
  modalRef: BsModalRef;
  sub: Subscription;
  SellerData;
  NAP;
  pageSize = 5;
  pageNo = 1;
  modalText: String = '';
  followUsers: Array<any> = [];
  
  ItemAvailable;
  ItemAvailableCount;
  
  ItemSold;
  ItemSoldCount;
  buttonText;
  followers;
  loading: Boolean = false;
  mainLoader;
  public options = {
    position: ['top', 'right'],
    lastOnBottom: false,
    preventDuplicates: true,
    timeout : 5000
  };
  modeType;
  type3;
  
  constructor(private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private _service: NotificationsService,
    private _location: Location,
    router: Router)
    
    {   
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.currentUser = userInfo ? userInfo.result : null;
      this.seller_id = userInfo.result ? userInfo.result.id : null;
      
      this.sub = this.route.params.subscribe((params) => {
        this.seller_id = params['sellerid'];
        this.modeType = params['type'];
      });
      
      if(this.modeType == 'trade'){
        this.type = 'trade';
      } else if(this.modeType == 'item') {
        this.type1 = 'item';
      } else {
        this.type3 = 'free'; 
      }
    }
    
    
    ngOnInit() {      
      this.mainLoader = '../../assets/images/BigLoader.gif';
      
      window.scrollTo(0, 0);
      if(this.type == "trade"){
        if (localStorage.getItem('currentMenu')) {
          localStorage.removeItem('currentMenu');
          localStorage.setItem('currentMenu', 'tradeHome');
        }
      }else{
        if (localStorage.getItem('currentMenu')) {
          localStorage.removeItem('currentMenu');
          localStorage.setItem('currentMenu', 'home');
          
        }
      }


      
      
      this.NAP = '../../assets/images/nap.jpg';
      this.SellerInfo();
      this.item_available();
      this.item_sold();
    }
    
    
    SellerInfo() {
      const params = {
        seller_id: this.seller_id
      };
      this.advtService.getSellerInfo(params).subscribe(data => {
        if(data){
          this.SellerData = data.result;
          this.buttonText = data.result.buttonText;
          this.followers = data.result.followers;
        } if(data.status == 400){
          this.alertService.warning("Not Registered as seller yet!")
          this.backClicked();
        }
        
      });
    }
    
    follow() {
      this.loading = true;
      const params = {
        user_id: this.seller_id,
        follower_id: this.currentUser.id
      };
      this.advtService.follow_seller(params).subscribe(data => {
        if (data.status === 200) {
          this.buttonText = data.buttonText;
          this.followers = data.followers;
          this.loading = false;
          
        }
      });
    }
    
    
    item_available() {
      this.ItemAvailable = [];
      const params = {
        seller_id: this.seller_id,
        limit: this.pageSize,
        offset: 0
      };
      this.ItemAvailable = [];
      this.advtService.item_available(params).subscribe(data => {
        if (data) {
          this.ItemAvailable = data.result;
          this.ItemAvailableCount = data.count;
        }
      });
    }
    
    
    item_sold() {
      // this.loading = true;
      const params = {
        user_id: this.seller_id,
        limit: this.pageSize,
        offset: 0,
        user_type: 'seller'
      };
      this.advtService.itemHistory(params).subscribe(data => {
        if (data.status === 200) {
          this.ItemSold = data.result;
          this.ItemSoldCount = data.count;
        }
      });
    }
    
    getFollowers(template: TemplateRef<any>, type: String) {
      this.modalText = type;
      const params = {
        type,
        user_id: this.seller_id,
        limit: 10,
        offset: 0,
      };
      this.advtService.getFollowerFollowing(params).subscribe(data => {
        if (data.status === 200) {
          this.followUsers = data.result;
        }
      });
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'gray modal-md' })
        );
      }
      
      /**
      * function to Disbale Modal
      * @param event
      */
      _hidemodal(event: any) {
        this.modalRef.hide();
      }
      
      /**
      * This function is used for pagination
      * @param data
      */
      pagingAgent_available(data) {
        
        // this.loading = true;
        this.ItemAvailable = [];
        this.pageNo = (data * this.pageSize) - this.pageSize;
        const params = {
          seller_id: this.seller_id,
          limit: this.pageSize,
          offset: this.pageNo
        };
        this.ItemAvailable = [];
        this.advtService.item_available(params).subscribe(data => {
          if (data.status === 200) {
            window.scrollTo(0, 0);
            this.ItemAvailable = data.result;
          }
        });
      }
      
      /**
      * This function is used for pagination
      * @param data
      */
      pagingAgent_sold(data) {
        // this.loading = true;
        this.ItemAvailable = [];
        this.pageNo = (data * this.pageSize) - this.pageSize;
        const params = {
          user_id: this.seller_id,
          limit: this.pageSize,
          offset: this.pageNo,
          user_type: 'seller'
        };
        this.advtService.itemHistory(params).subscribe(data => {
          if (data.status === 200) {
            window.scrollTo(0, 0);
            this.ItemSold = data.result;
            this.ItemSoldCount = data.count;
          }
        });
      }
      
      
      backClicked() {
        this._location.back();
      }
      
      
    }
    
    
    


// WEBPACK FOOTER //
// ./src/app/authorized-data/seller-info/seller-info.component.ts